import { Menu, Popover, Transition } from "@headlessui/react"
import { useState } from "react"
import Bell from "../components/svg/Bell"
import { useQuery } from "react-query"
import {
  getParentNotification,
  getSchoolNotification,
  getTutorNotification
} from "../API/API"
import { HiDotsHorizontal } from "react-icons/hi"
import { IoMdDoneAll } from "react-icons/io"
import { api } from "../util/APIConfig"
import { ClipLoader } from "react-spinners"
import jwtDecode from "jwt-decode"

export default function Notifications() {
  const [alertsData, setAlertsData] = useState([])
  const role = jwtDecode(localStorage.getItem("token")).role
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [notificationCount, setNotificationCount] = useState(0)

  const { isSuccess: isSuccessAlerts, isLoading: isLoadingStudentAlerts } =
    useQuery(
      ["student_alerts"],
      async () =>
        await api("/Notification/Alert/GetAllStudentAlert", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }),
      {
        onSuccess: data => {
          let allData = data.data.data
          setNotificationCount(allData.length)
          allData.length > 100 && (allData = allData.slice(0, 100))
          const formattedData = allData.map(value => ({
            ...value,
            color: getColorForData(value.title),
            alertTitle: getAlertTitle(value.title)
          }))
          setAlertsData(formattedData)
        },
        enabled: role === "Student",
        refetchOnWindowFocus: false
      }
    )

  const { isSuccess: isSuccessParentAlerts, isLoading: isLoadingParentAlerts } =
    useQuery(["parent_notifications"], () => getParentNotification(), {
      onSuccess: data => {
        let allData = data.data.data
        setNotificationCount(allData.length)
        allData.length > 100 && (allData = allData.slice(0, 100))
        const formattedData = allData.map(value => ({
          ...value,
          color: "[#9D4B94]",
          notifyAlert: value.title,
          title: 0
        }))
        setAlertsData(formattedData)
        // setNotificationCount(parseInt(data.data.message))
      },
      enabled: role === "Parent",
      refetchOnWindowFocus: false
    })

  const { isSuccess: isSuccessSchoolAlerts, isLoading: isLoadingSchoolAlerts } =
    useQuery(["school_notifications"], () => getSchoolNotification(), {
      onSuccess: data => {
        let allData = data.data.data
        setNotificationCount(allData.length)
        allData.length > 100 && (allData = allData.slice(0, 100))
        const formattedData = allData.map(value => ({
          ...value,
          color: "[#9D4B94]",
          notifyAlert: value.title
        }))
        setAlertsData(formattedData)
      },
      enabled: role === "School Manager",
      refetchOnWindowFocus: false
    })

  const {
    isSuccess: isSuccessTutorNotifications,
    isLoading: isLoadingTutorNotifications
  } = useQuery(["tutor_notifications"], () => getTutorNotification(), {
    onSuccess: data => {
      console.log(data.data)
      let allData = data.data
      setNotificationCount(allData.length)
      allData.length > 100 && (allData = allData.slice(0, 100))
      const formattedData = allData.map(value => ({
        ...value,
        color: "[#9D4B94]",
        notifyAlert: value,
        title: null
      }))
      setAlertsData(formattedData)
    },
    enabled: role === "Tutor" || role === "Senior Tutor",
    refetchOnWindowFocus: false
  })

  const markNotificationRead = async id => {
    let url = ""
    if (role === "Parent") {
      url = "Parent/"
    } else if (role === "School Manager") {
      url = "School/"
    } else if (role === "Student") {
      url = "Student/"
    }
    try {
      await api.post(
        `/Notification/${url}Notification/ReadNotificationLog?NotificationId=${id}`
      )
      updateData(id)
    } catch (error) {
      console.log(error)
    }
  }

  const markAlertRead = async id => {
    let url = ""
    if (role === "Parent") {
      url = "Parent/"
    } else if (role === "School Manager") {
      url = "School/"
    } else if (role === "Student") {
      url = "Student/"
    }
    try {
      await api.post(
        `/Notification/${url}Notification/MarkAlertAsRead?alertId=${id}`
      )
      updateData(id)
    } catch (error) {
      console.log(error)
    }
  }

  const updateData = id => {
    const updatedData = alertsData.map(item => {
      if (item.id === id) {
        return {
          ...item,
          isRead: true
        }
      }
      return item
    })
    setAlertsData(updatedData)
    setNotificationCount(notificationCount - 1)
    console.log(updatedData)
  }

  function getColorForData(value) {
    if (value === 0) return "[#9D4B94]"
    else if (value === 1) return "[#DA5A5C]"
    else if (value === 2) return "[#FFAA06]"
    else if (value === 3) return "[#06D79E]"
    else if (value === 4) return "[#485AFF]"
    else return "[#9D4B94]"
  }
  function getAlertTitle(value) {
    if (value === 1) return "Significantly behind progress"
    else if (value === 2) return "Unresponsive Student"
    else if (value === 3) return "Tutor Swap"
    else if (value === 4) return "Other"
  }

  const handleMouseEnter = index => {
    setHoveredIndex(index)
  }

  const handleMouseLeave = () => {
    setHoveredIndex(null)
  }

  // Item component
  const NotificationItem = ({ items }) => {
    const [fullDescription, setFullDescription] = useState(false)
    const isNotification = items.isNotificationAdjustment

    const handleItemClick = () => {
      if (items.navigatableLink) {
        window.open(items.navigatableLink, '_self')
      }
    }

    return (
      <li
        className={`flex cursor-pointer items-center gap-4 px-4 py-3 ${
          hoveredIndex === items.id ? "hovered hover:bg-neutral-5" : ""
        } ${items.navigatableLink ? "hover:bg-neutral-100" : ""}`}
        onMouseOver={() => {
          setFullDescription(true)
          handleMouseEnter(items.id)
        }}
        onMouseOut={() => {
          setFullDescription(false)
          handleMouseLeave()
        }}
        onClick={handleItemClick}
      >
        <div
          className={`min-h-[16px] min-w-[16px] rounded-full bg-${items.color}`}
        />

        {items.title === null ? (
          //This means its notification
          isNotification ? (
            //This is automatic
            <p className="subtitle-2 text-neutral-4d">
              <b>{items.notifyAlert}</b>{" "}
              {!fullDescription && items.description?.length > 20
                ? items.description.slice(0, 20) + " ..."
                : items.description}
              <span className="underline" onClick={() => {}}>
                {items.notificationLink ? (
                  <a
                    href={items.notificationLink}
                    target="_blank"
                    className="text-primary"
                    rel="noreferrer"
                  >
                    {items.notificationLink?.length > 15
                      ? " " + items.notificationLink.slice(0, 15) + " ..."
                      : " " + items.notificationLink}
                  </a>
                ) : (
                  ""
                )}
              </span>
            </p>
          ) : (
            //This will be notification log
            <p className="subtitle-2 text-neutral-4d">
              <b>{items.notifyAlert ? items.notifyAlert : ""}</b>{" "}
              {!fullDescription && items.description?.length > 20
                ? items.description.slice(0, 20) + " ..."
                : items.description}
              <span className="underline" onClick={() => {}}>
                {items.notificationLink ? (
                  <a
                    href={items.notificationLink}
                    target="_blank"
                    className="text-primary"
                    rel="noreferrer"
                  >
                    {items.notificationLink?.length > 15
                      ? " " + items.notificationLink.slice(0, 15) + " ..."
                      : " " + items.notificationLink}
                  </a>
                ) : (
                  ""
                )}
              </span>
            </p>
          )
        ) : //This means its alert
        items.title === 0 ? (
          <div className="flex w-[100%] items-center">
            <p className="subtitle-2 w-[90%] py-1 text-neutral-4d">
              <b>{items.notifyAlert}</b>{" "}
              {!fullDescription && items.description?.length > 25
                ? items.description.slice(0, 25) + " ..."
                : items.description}
              <span className="underline" onClick={() => {}}>
                {items.link ? (
                  <a
                    href={items.link}
                    target="_blank"
                    className="text-primary"
                    rel="noreferrer"
                  >
                    {items.link?.length > 15
                      ? " " + items.link.slice(0, 15) + " ..."
                      : " " + items.link}
                  </a>
                ) : (
                  ""
                )}
              </span>
            </p>
            {hoveredIndex === items.id && !items.isRead && (
              <div className="flex w-[4%] justify-start">
                <Popover className="relative">
                  {({ open }) => (
                    /* Use the `open` state to conditionally change the direction of the chevron icon. */
                    <>
                      <Popover.Button
                        className={`rounded-full  p-1 focus:outline-primary ${
                          open ? "bg-primary" : "bg-white"
                        }`}
                      >
                        <HiDotsHorizontal
                          className={`text-[20px] sml:text-[20px] ${
                            open ? "text-white" : "text-neutral-1"
                          }`}
                        />
                      </Popover.Button>
                      <Popover.Panel className="shadow-3 absolute right-10 top-1/2 w-[160px] -translate-y-1/2 transform rounded-2xl border border-primary bg-white">
                        <div className="flex flex-col gap-5 px-3 py-3">
                          <div
                            className="flex cursor-pointer items-center"
                            onClick={() => {
                              markNotificationRead(items.id)
                              console.log(alertsData)
                            }}
                          >
                            <IoMdDoneAll color="#06D79E" />
                            <span className="pl-4 text-[12px] text-neutral-1">
                              Mark as read
                            </span>
                          </div>
                        </div>
                      </Popover.Panel>
                    </>
                  )}
                </Popover>
              </div>
            )}
          </div>
        ) : (
          <div className="flex w-[100%] items-center">
            <p className="subtitle-2 text-neutral-4d">
              Alert has been raised on you.{" "}
              <b>{items.title ? items.alertTitle : ""}</b>{" "}
              {!fullDescription && items.description?.length > 15
                ? items.description.slice(0, 15) + " ..."
                : items.description}
              <span className="underline" onClick={() => {}}>
                {items.notificationLink && (
                  <a
                    href={items.notificationLink}
                    target="_blank"
                    className="text-primary"
                    rel="noreferrer"
                  >
                    {items.notificationLink?.length > 15
                      ? " " + items.notificationLink.slice(0, 15) + " ..."
                      : " " + items.notificationLink}
                  </a>
                )}
              </span>
            </p>
            {hoveredIndex === items.id && !items.isRead && (
              <div className="flex w-[4%] justify-start">
                <Popover className="relative">
                  {({ open }) => (
                    /* Use the `open` state to conditionally change the direction of the chevron icon. */
                    <>
                      <Popover.Button
                        className={`rounded-full  p-1 focus:outline-primary ${
                          open ? "bg-primary" : "bg-white"
                        }`}
                      >
                        <HiDotsHorizontal
                          className={`text-[20px] sml:text-[20px] ${
                            open ? "text-white" : "text-neutral-1"
                          }`}
                        />
                      </Popover.Button>
                      <Popover.Panel className="shadow-3 absolute right-10 top-1/2 w-[160px] -translate-y-1/2 transform rounded-2xl border border-primary bg-white">
                        <div className="flex flex-col gap-5 px-3 py-3">
                          <div
                            className="flex cursor-pointer items-center"
                            onClick={() => {
                              markAlertRead(items.id)
                            }}
                          >
                            <IoMdDoneAll color="#06D79E" />
                            <span className="pl-4 text-[12px] text-neutral-1">
                              Mark as read
                            </span>
                          </div>
                        </div>
                      </Popover.Panel>
                    </>
                  )}
                </Popover>
              </div>
            )}
          </div>
          
        )}
      </li> //{items.title === 0 ? (
      // <div className="flex w-[100%] items-center">
      //   <p className="subtitle-2 w-[90%] py-1 text-neutral-4d">
      //     <b>{items.notifyAlert}</b>{" "}
      //     {!fullDescription && items.description?.length > 25
      //       ? items.description.slice(0, 25) + " ..."
      //       : items.description}
      //     <span className="underline" onClick={() => {}}>
      //       {items.link ? (
      //         <a
      //           href={items.link}
      //           target="_blank"
      //           className="text-primary"
      //           rel="noreferrer"
      //         >
      //           {items.link?.length > 15
      //             ? " " + items.link.slice(0, 15) + " ..."
      //             : " " + items.link}
      //         </a>
      //       ) : (
      //         ""
      //       )}
      //     </span>
      //   </p>
      //   {hoveredIndex === items.id && !items.isRead && (
      //     <div className="flex w-[4%] justify-start">
      //       <Popover className="relative">
      //         {({ open }) => (
      //           /* Use the `open` state to conditionally change the direction of the chevron icon. */
      //           <>
      //             <Popover.Button
      //               className={`rounded-full  p-1 focus:outline-primary ${
      //                 open ? "bg-primary" : "bg-white"
      //               }`}
      //             >
      //               <HiDotsHorizontal
      //                 className={`text-[20px] sml:text-[20px] ${
      //                   open ? "text-white" : "text-neutral-1"
      //                 }`}
      //               />
      //             </Popover.Button>
      //             <Popover.Panel className="shadow-3 absolute top-1/2 right-10 w-[160px] -translate-y-1/2 transform rounded-2xl border border-primary bg-white">
      //               <div className="flex flex-col gap-5 px-3 py-3">
      //                 <div
      //                   className="flex cursor-pointer items-center"
      //                   onClick={() => {
      //                     markNotificationRead(items.id)
      //                     console.log(alertsData)
      //                   }}
      //                 >
      //                   <IoMdDoneAll color="#06D79E" />
      //                   <span className="pl-4 text-[12px] text-neutral-1">
      //                     Mark as read
      //                   </span>
      //                 </div>
      //               </div>
      //             </Popover.Panel>
      //           </>
      //         )}
      //       </Popover>
      //     </div>
      //   )}
      // </div>
      // ) : isNotification ? (
      // <p className="subtitle-2 text-neutral-4d">
      //   <b>{items.notifyAlert}</b>{" "}
      //   {!fullDescription && items.description?.length > 20
      //     ? items.description.slice(0, 20) + " ..."
      //     : items.description}
      //   <span className="underline" onClick={() => {}}>
      //     {items.notificationLink ? (
      //       <a
      //         href={items.notificationLink}
      //         target="_blank"
      //         className="text-primary"
      //         rel="noreferrer"
      //       >
      //         {items.notificationLink?.length > 15
      //           ? " " + items.notificationLink.slice(0, 15) + " ..."
      //           : " " + items.notificationLink}
      //       </a>
      //     ) : (
      //       ""
      //     )}
      //   </span>
      // </p>
      //  ) : (
      // <p className="subtitle-2 text-neutral-4d">
      //   Alert has been raised on you.{" "}
      //   <b>{items.title ? items.alertTitle : ""}</b>{" "}
      //   {!fullDescription && items.description?.length > 15
      //     ? items.description.slice(0, 15) + " ..."
      //     : items.description}
      //   <span className="underline" onClick={() => {}}>
      //     {items.notificationLink && (
      //       <a
      //         href={items.notificationLink}
      //         target="_blank"
      //         className="text-primary"
      //         rel="noreferrer"
      //       >
      //         {items.notificationLink?.length > 15
      //           ? " " + items.notificationLink.slice(0, 15) + " ..."
      //           : " " + items.notificationLink}
      //       </a>
      //     )}
      //   </span>
      // </p>
      //  )}
    )
  }

  return (
    <div className="relative z-10 flex w-[17px] items-center md:w-full md:max-w-[25px]">
      {isLoadingStudentAlerts ||
      isLoadingParentAlerts ||
      isLoadingTutorNotifications ||
      isLoadingSchoolAlerts ? (
        <div className="absolute right-[-8px] top-[-8px] flex h-full w-full items-center justify-center">
          <ClipLoader color="#DA5A5C" size={15} />
        </div>
      ) : (
        notificationCount > 0 && (
          <div
            className={`absolute  flex  ${
              notificationCount > 99
                ? "right-[-14px] top-[-14px] h-[25px] w-[25px]"
                : "right-[-8px] top-[-8px] h-[20px] w-[20px]"
            } items-center justify-center rounded-full bg-danger`}
          >
            <span className="items-center text-[10px] text-white">
              {notificationCount > 99 ? "99+" : notificationCount}
            </span>
          </div>
        )
      )}
      <Menu>
        <Menu.Button>
          <Bell fill="#888888" />
        </Menu.Button>
        <Transition
          enter="transition duration-200 ease-in"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-200 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Menu.Items className=" shadow-3 absolute -right-10 top-7 z-50  w-[250px] rounded-xl bg-white md:right-0 md:w-[338px]">
            <p className="subtitle-1 px-5 py-4 font-medium text-primary">
              Notifications
            </p>
            <div className="h-[1px] bg-border-line" />
            {(isSuccessAlerts ||
              isSuccessParentAlerts ||
              isSuccessTutorNotifications ||
              isSuccessSchoolAlerts) &&
            alertsData.length > 0 ? (
              <ul className="curriculum-scroll mr-1 flex max-h-[277px] flex-col">
                {alertsData.map((items, index) => (
                  <NotificationItem key={index} items={items} />
                ))}
              </ul>
            ) : (
              <div className="flex min-h-[170px] items-center justify-center">
                <span className="subtitle-2 text-neutral-4d">
                  No Notifications Right Now!
                </span>
              </div>
            )}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
